<template>
  <div class="experience" :class="content.indentation ? content.indentation : 'none'">
    <div class="date" :class="{ selected: isSelected && currentSection === 'date' }" @click="onClicked('date')">
      {{ content.date }}
    </div>
    <div class="timeline" />
    <div class="data">
      <div
        class="section job"
        :class="{
          selected: isSelected && (currentSection === 'job' || currentSection === 'client'),
        }"
        @click="onClicked('job')"
      >
        <span v-if="content.job" class="subtitle">poste :</span>
        <span v-if="content.job" class="text">{{ content.job }}</span>
        <span v-if="content.job && content.client" class="spacer" />
        <span class="client">
          {{ content.client }}
        </span>
      </div>
      <div
        v-if="content.info"
        class="section info"
        :class="{ selected: isSelected && currentSection === 'info' }"
        @click="onClicked('info')"
      >
        <span class="subtitle">Contexte</span>
        <span v-html="content.info" />
      </div>
      <div
        v-if="content.missions && content.missions.length > 0"
        class="section missions"
        :class="{ selected: isSelected && currentSection === 'missions' }"
        @click="onClicked('missions')"
      >
        <div class="subtitle">{{ $t(`resume.sections.${resumeLanguage}.common-missions`) }}</div>
        <div class="items" v-html="content.missions"></div>
      </div>
      <div
        v-if="content.technos"
        class="section technos"
        :class="{ selected: isSelected && currentSection === 'technos' }"
        @click="onClicked('technos')"
      >
        <span class="subtitle">{{ $t(`resume.sections.${resumeLanguage}.common-technical-environment`) }}</span>
        <div class="items" v-html="content.technos"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExperienceComponent',
  props: {
    content: {
      type: Object,
      required: true,
    },
    onClicked: {
      type: Function,
      required: true,
    },
    currentSection: {
      type: String,
      default: '',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    resumeLanguage: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.section,
.date,
.client {
  &:hover,
  &.selected {
    background-color: #fff9ef;
    cursor: pointer;
    border-radius: 12px;
  }

  &.job {
    margin: 0;
  }
}
</style>
